import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';
import { stripQueryParams } from '@shared/navigation/navigation';
export function ExportRecordingLink({ load }) {
    const [callId, setCallId] = useState(() => new URLSearchParams(window.location.search).get('recordingCall'));
    const [state, setState] = useState({ status: 'idle' });
    const active = useRef(true);
    const audioUrl = useRef(null);
    useEffect(() => {
        active.current = true;
        return () => {
            active.current = false;
            if (audioUrl.current !== null)
                URL.revokeObjectURL(audioUrl.current);
        };
    }, []);
    if (callId === null)
        return null;
    const close = () => {
        active.current = false;
        if (audioUrl.current !== null)
            URL.revokeObjectURL(audioUrl.current);
        stripQueryParams(['recordingCall']);
        setCallId(null);
    };
    const open = async () => {
        setState({ status: 'loading' });
        try {
            if (!/^[A-Za-z0-9_-]{1,128}$/.test(callId))
                throw new Error('This recording link is invalid.');
            const blob = await load(callId);
            if (!active.current)
                return;
            const url = URL.createObjectURL(blob);
            audioUrl.current = url;
            setState({ status: 'ready', url });
        }
        catch (reason) {
            if (active.current) {
                setState({ status: 'failed', error: reason instanceof Error ? reason.message : 'Could not load this recording.' });
            }
        }
    };
    return (_jsxs(Dialog, { open: true, onClose: close, fullWidth: true, maxWidth: "sm", children: [_jsx(DialogTitle, { children: "Exported call recording" }), _jsxs(DialogContent, { children: [_jsx(Typography, { variant: "body2", sx: { mb: 2 }, children: "Access is checked when you load the recording. Deleted or expired recordings are unavailable." }), state.status === 'failed' && _jsx(Alert, { severity: "error", children: state.error }), state.status === 'ready' && (_jsx("audio", { controls: true, src: state.url, "aria-label": "Call recording", style: { width: '100%' } }))] }), _jsxs(DialogActions, { sx: { flexWrap: 'wrap' }, children: [_jsx(Button, { onClick: close, children: "Close" }), state.status !== 'ready' && _jsx(Button, { variant: "contained", disabled: state.status === 'loading', onClick: () => void open(), children: state.status === 'loading' ? 'Loading...' : 'Load recording' })] })] }));
}
